module.exports = __webpack_public_path__ + "img/cuff_button_diameter.82a511a3.png";